import { render } from "./QuizTypeIntInput.vue?vue&type=template&id=01882660&scoped=true"
import script from "./QuizTypeIntInput.vue?vue&type=script&lang=js"
export * from "./QuizTypeIntInput.vue?vue&type=script&lang=js"

import "./QuizTypeIntInput.vue?vue&type=style&index=0&id=01882660&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01882660"]])

export default __exports__